export default "__VITE_ASSET__jA21St3Q__"